import styled from 'styled-components';

export const CascaderStyled = styled.div`
  .cascader-box {
    .ant-form-item-label {
      text-align: left;
      width: 169px;
      font-size: 16px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
      border: 1px solid #d9d9d9;
      border-right: 0;
      background: #edf0f0;
      height: 47px;
      color: ${(props) => props.theme[props.brand].input.color};
    }
    .ant-form-item-no-colon {
      margin-top: 8px;
      background: #edf0f0;
      font-size: 16px;
      border-radius: 0px;
      padding: 0 11px;
    }
    .ant-form-item-control {
      position: relative;
      * {
        border-radius: 0px;
      }
      input {
        height: ${(props) => props.height} !important;
        &:hover {
          border-color: ${(props) =>
            props.theme[props.brand].formSelect.addSingSelectBdNew};
        }
      }
      .ant-input:focus,
      .ant-input-focused {
        border-color: ${(props) =>
          props.theme[props.brand].formSelect.addSingSelectBdNew};
        box-shadow: 0 0 0 0px rgba(131, 255, 49, 0.2);
      }
      .ant-cascader-picker-label:hover + .ant-cascader-input {
        border-color: ${(props) =>
          props.theme[props.brand].formSelect.addSingSelectBdNew};
      }
      .ant-cascader-picker:focus .ant-cascader-input {
        box-shadow: 0 0 0 0 rgba(24, 144, 255, 0.2);
        border-color: ${(props) =>
          props.theme[props.brand].formSelect.addSingSelectBdNew};
      }
      .ant-cascader-picker-arrow {
        position: absolute;
        right: 10px;
        top: 24px;
      }
      .ant-input {
        font-size: 16px;
      }
    }
  }
`;
